// Generated by purs version 0.15.0
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
var Cash = /* #__PURE__ */ (function () {
    function Cash() {

    };
    Cash.value = new Cash();
    return Cash;
})();
var Online = /* #__PURE__ */ (function () {
    function Online() {

    };
    Online.value = new Online();
    return Online;
})();
var Card = /* #__PURE__ */ (function () {
    function Card() {

    };
    Card.value = new Card();
    return Card;
})();
var Prepaid = /* #__PURE__ */ (function () {
    function Prepaid() {

    };
    Prepaid.value = new Prepaid();
    return Prepaid;
})();
var eqPaymentMethod = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Cash && y instanceof Cash) {
                return true;
            };
            if (x instanceof Online && y instanceof Online) {
                return true;
            };
            if (x instanceof Card && y instanceof Card) {
                return true;
            };
            if (x instanceof Prepaid && y instanceof Prepaid) {
                return true;
            };
            return false;
        };
    }
};
var ordPaymentMethod = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Cash && y instanceof Cash) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Cash) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Cash) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Online && y instanceof Online) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Online) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Online) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Card && y instanceof Card) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Card) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Card) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Prepaid && y instanceof Prepaid) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Orders.Types.PaymentMethod (line 23, column 1 - line 23, column 34): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqPaymentMethod;
    }
};
var genericPaymentMethod = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Cash.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Online.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Card.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return Prepaid.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.PaymentMethod (line 12, column 1 - line 12, column 81): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Cash) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Online) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Card) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof Prepaid) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types.PaymentMethod (line 12, column 1 - line 12, column 81): " + [ x.constructor.name ]);
    }
};
var showPaymentMethod = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPaymentMethod)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Cash";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Online";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Card";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Prepaid";
        }
    })))))
};
var unscrambleDecodePaymentMethod = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericPaymentMethod)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Cash";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Online";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Card";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Prepaid";
        }
    })))))(Unscramble_Enum.defaultEnumOptions)
};
var encodePaymentMethod = {
    encode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericEncodeEnum(genericPaymentMethod)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Cash";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Online";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Card";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Prepaid";
        }
    })))))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
var decodePaymentMethod = {
    decode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericDecodeEnum(genericPaymentMethod)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Cash";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Online";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Card";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Prepaid";
        }
    })))))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
export {
    Cash,
    Online,
    Card,
    Prepaid,
    genericPaymentMethod,
    showPaymentMethod,
    eqPaymentMethod,
    decodePaymentMethod,
    unscrambleDecodePaymentMethod,
    encodePaymentMethod,
    ordPaymentMethod
};
//# sourceMappingURL=index.js.map
